import { announceToOtherTabs, onSignalFromOtherTab } from "./crossTabSignal";

/** The tab that saved a consent change reloads itself; other open tabs only hear about it this way. */
const COOKIE_CONSENT_CHANGED_KEY = "cookie_consent_changed_at";

export function announceCookieConsentChange(): void {
    announceToOtherTabs(COOKIE_CONSENT_CHANGED_KEY);
}

export function onCookieConsentChangedElsewhere(callback: () => void): void {
    onSignalFromOtherTab(COOKIE_CONSENT_CHANGED_KEY, callback);
}

/**
 * The latest choice saved from this browser while signed in, shared by every tab. A tab that
 * missed the cross-tab notice (its listener was not registered yet) can still refuse to boot a
 * consent-gated vendor from a response that predates the withdrawal. The choice is tied to the
 * account that made it: a sign-in to another account on the same browser starts from that
 * account's own choice, not the previous one's opt-out.
 */
const BROWSER_CHOICE_KEY = "cookie_consent_browser_choice";

export function rememberBrowserCookieChoice(accountUuid: string | null, choice: string): void {
    if (!accountUuid) {
        return;
    }
    try {
        localStorage.setItem(BROWSER_CHOICE_KEY, JSON.stringify({ account: accountUuid, choice }));
    } catch {
        // Storage unavailable; the server gate still applies.
    }
}

export function browserCookieChoice(accountUuid: string): string | null {
    try {
        const stored = JSON.parse(localStorage.getItem(BROWSER_CHOICE_KEY) ?? "null") as { account?: string; choice?: string } | null;
        return stored?.account === accountUuid && typeof stored.choice === "string" ? stored.choice : null;
    } catch {
        return null;
    }
}

/** On logout / confirmed expiry, so the next account on this browser starts from its own choice. */
export function forgetBrowserCookieChoice(): void {
    try {
        localStorage.removeItem(BROWSER_CHOICE_KEY);
    } catch {
        // Nothing to forget.
    }
}
